import { SessionStorageService } from 'ngx-webstorage';
import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, of, ReplaySubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { SharedService } from '../shared/shared.service';
import {
  catchError,
  first,
  mergeMap,
  shareReplay,
  switchMap,
  switchMapTo,
  tap,
} from 'rxjs/operators';
import { FormService } from '../shared/form.service';
import * as moment from 'moment';
import { PaymentService } from '../services/payment.service';
import { LocalStorageService } from 'ngx-localstorage';
import { ProposalService } from '../shared/proposal.service';
import { KpiEnum } from '../interfaces/kpi.enum';

@Injectable({
  providedIn: 'root',
})
export class SubmitOfferGuard implements CanActivate {
  subject = new ReplaySubject<any>(1);
  route;

  constructor(
    public sharedService: SharedService,
    public router: Router,
    private http: HttpClient,
    private storage: LocalStorageService,
    private paymentService: PaymentService,
    private formService: FormService,
    private proposalService: ProposalService,
    private sessionStorage: SessionStorageService
  ) {

  }

  createData(res?) {
    let currentFormData = this.formService.currentForm.getRawValue();
    delete currentFormData.vehicleDTO.isLeased;
    const { sAgreeMarketing, emailCommunication } = currentFormData.agreement;
    ['postCodeX', 'addressX'].map((item) => {
      [
        'personOwnerData',
        'personInsurerData',
        'personPayerData',
        'companyOwnerData',
      ].map((group) => {
        if (currentFormData?.[group]?.[item]) {
          delete currentFormData[group][item];
        }
      });
    });
    if (!currentFormData?.isCompany) {
      if (typeof currentFormData.personOwnerData.dDateOfBirth !== 'string') {
        currentFormData.personOwnerData.dDateOfBirth =
          currentFormData.personOwnerData.dDateOfBirth.format('yyyy-MM-DD') +
          'T00:00:00.000+0000';
      }
      if (
        currentFormData.personInsurerData.dDateOfBirth &&
        typeof currentFormData.personInsurerData.dDateOfBirth !== 'string'
      ) {
        currentFormData.personInsurerData.dDateOfBirth =
          currentFormData.personInsurerData.dDateOfBirth.format('yyyy-MM-DD') +
          'T00:00:00.000+0000';
      }
      currentFormData.personOwnerData.nameInLatin =
        (currentFormData?.greenCard?.firstNameInLatin &&
          `${currentFormData.greenCard.firstNameInLatin} ${currentFormData.greenCard.middleNameInLatin} ${currentFormData.greenCard.lastNameInLatin}`) ||
        null;
      currentFormData.personOwnerData.addressInLatin =
        currentFormData?.greenCard?.addressInLatin || null;
      // currentFormData.personOwnerData.sAgreeMarketing = sAgreeMarketing;
      currentFormData.personInsurerData.sAgreeMarketing = sAgreeMarketing;
      // currentFormData.personPayerData.sAgreeMarketing = sAgreeMarketing;
      currentFormData.personOwnerData.phoneNumber = currentFormData
        .personOwnerData.phoneNumber
        ? currentFormData.personOwnerData.phoneNumber.replace('+', '00')
        : null;
      currentFormData.personInsurerData.phoneNumber = currentFormData
        .personInsurerData.phoneNumber
        ? currentFormData.personInsurerData.phoneNumber.replace('+', '00')
        : null;
      currentFormData.personPayerData.phoneNumber = currentFormData
        .personPayerData.phoneNumber
        ? currentFormData.personPayerData.phoneNumber.replace('+', '00')
        : null;

      const partnerType = currentFormData.personOwnerData.partnerType;
      currentFormData.personInsurerData.partnerType = 'P';
      currentFormData.personPayerData.partnerType = 'P';
    }
    if (currentFormData?.isCompany) {
      currentFormData.companyOwnerData.nameInLatin =
        currentFormData?.greenCard?.firstNameInLatin || null;
      currentFormData.companyOwnerData.addressInLatin =
        currentFormData?.greenCard?.addressInLatin || null;
      // currentFormData.companyOwnerData.sAgreeMarketing = sAgreeMarketing;
      currentFormData.personInsurerData.sAgreeMarketing = sAgreeMarketing;
      // currentFormData.personPayerData.sAgreeMarketing = sAgreeMarketing;
      currentFormData.companyOwnerData.phoneNumber = currentFormData
        .companyOwnerData.phoneNumber
        ? currentFormData.companyOwnerData.phoneNumber.replace('+', '00')
        : null;
      currentFormData.personInsurerData.phoneNumber = currentFormData
        .personInsurerData.phoneNumber
        ? currentFormData.personInsurerData.phoneNumber.replace('+', '00')
        : null;
      currentFormData.personPayerData.phoneNumber = currentFormData
        .personPayerData.phoneNumber
        ? currentFormData.personPayerData.phoneNumber.replace('+', '00')
        : null;

      const partnerType = currentFormData.companyOwnerData.partnerType;
      currentFormData.personInsurerData.partnerType = 'P';
      currentFormData.personPayerData.partnerType = 'P';
    }
    currentFormData.vehicleDTO.firstRegDate = currentFormData?.vehicleDTO
      ?.firstRegDate
      ? moment(currentFormData?.vehicleDTO?.firstRegDate).format('yyyy-MM-DD')
      : null;

    let headersData = {
      insurancesDates: currentFormData.insurancesDates,
      vehicleDTO: currentFormData.vehicleDTO,
      [!currentFormData.isCompany ? 'personOwnerData' : 'companyOwnerData']:
        !currentFormData.isCompany
          ? currentFormData.personOwnerData
          : currentFormData.companyOwnerData,
      personInsurerData: currentFormData.personInsurerData,
      personPayerData: currentFormData.personInsurerData,
      companyBeneficiaryData: currentFormData.companyBeneficiaryData,
      vehicleDamages: res?.vehicleDamages || null, //?? only old car
      addPolicyDataDTO: null, // ? missing sticker number !
      regTypeId: currentFormData.regTypeId,
      emailCommunication: emailCommunication,
      isSinglePaymentGO: false,
      numberOfInstallments: currentFormData.numberOfInstallments,
      insSumBGN: currentFormData?.insSumBGN,
      insSumEURO: currentFormData?.insSumEURO || null,
      packageType: currentFormData.packageType,
      greenCardCert: currentFormData.greenCardCert,
      eManual: 'EMAIL', // ????
      mtplLimit:
        currentFormData.packageType.indexOf('V') === -1
          ? currentFormData.mtplLimit
          : null, // -> от формата
      deductible: currentFormData.deductible,
      additionalRisk: null,
      claimType: null,
      crossSale: 'N',
    };
    this.http
      .post('/api/v1/policy/', headersData)
      .pipe(


        tap(
          this.proposalService
            .insertTrackingData()
            .pipe(
              catchError((error) => {
                throw error;
              })
            )
            .subscribe()
        ),
        catchError((error) => {
          this.sharedService.loadingStep = false;
          return of(this.router.createUrlTree(['somethingWentWrong']));
        }),

        switchMap((res) => {
          if (res instanceof UrlTree) {
            return of(res);
          }
          const policyData = res as any;
          this.proposalService.trackingFinalData(policyData);
          return this.paymentService
            .sendPolicyData(this.storage.get('dueId'), {
              policyRef: policyData.policyRef,
              contractId: policyData.contractId,
            })
            .pipe(
              switchMapTo(of(res)),
              catchError((error) => {
                this.sharedService.loadingStep = false;
                return of(this.router.createUrlTree(['somethingWentWrong']));
              })
            );
        }),
        mergeMap((res: any) => {
          this.sharedService.loadingStep = false;
          if (res) {
            if (res instanceof UrlTree) {
              return of(this.router.createUrlTree(['somethingWentWrong']));
            }
            this.route.data = { ...this.route.data, dto: res };
            this.sharedService.updatePrintObject({
              policy: headersData,
              response: res,
            });

            if (headersData.vehicleDTO.vehRegPlate) {
              return of(this.router.createUrlTree(['printPolicy']));
            } else {
              return of(this.router.createUrlTree(['newPrintPolicy']));
            }
          } else {
            return of(this.router.createUrlTree(['somethingWentWrong']));
          }
        })
      )
      .subscribe((res) => {
        this.subject.next(res);
      });
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    this.route = route;
    this.sharedService.loadingStep = { title: 'loading.almostDone' };
    let currentFormData = this.formService.currentForm.getRawValue();
    this.createData();
    // });
    return this.subject.pipe(first());
  }
}
